// extracted by mini-css-extract-plugin
module.exports = {"title":"Documents_title__B76Q8","selects":"Documents_selects__JRA7T"};